import { useParams } from "react-router-dom";
import GenericBody from "../Componentes/GenericBody";
import NavBar from "../Componentes/NavBar";
import axios from "axios";
import { useEffect, useState } from "react";
import Overlay from "../Componentes/Overlay";
import styled from "styled-components";
import Tabela from "../Componentes/Utils/Tabela";
import { formatarData } from "../Funcoes/FormatarData";

const BackgroundDiv = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    gap: 10px;
`
const ColabInfoContainer = styled.div`
    width: 450px;
    height: 100%;
    background-color: #2E3A44;
    border-radius: 12px;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
    display: flex;
    flex-direction: column;
`
const ContainerImageColab = styled.div`
    width: 200px;
    height: 200px;
    border-radius: 50%;
    background-color: #E5E7EB;
    margin: 35px auto;
    overflow: hidden;
    img {
        width: 100%;
        height: 100%;
        border-radius: 50%;
        object-fit: cover;
    }
`
const Separator = styled.div`
    width: 75%;
    height: 2px;
    background-color: #E5E7EB;
    margin: 15px auto;
`
const MainText = styled.p`
    font-size: 16px;
    color: #E2E8F0;
    margin: 0 auto;
    text-align: center;
    font-weight: bold;
`
const MainText2 = styled.p`
    font-size: 14px;
    color: #94A3B8;
    margin: 0 auto;
    text-align: center;
    font-weight: normal;
`
const EpisContainer = styled.div`
    display: flex;
    width: calc( 100% - 450px );
    height: 100%;
    flex-direction: column;
    gap: 10px;
`

const EpiTabelaContainer = styled.div`
    width: 100%;
    display: flex;
    border-radius: 10px;
    overflow: hidden;
`

const EpisObrgContainer = styled.div`
    width: 100%;
    max-height: calc( 40% - 5px );
    background-color: #2E3A44;
    border-radius: 12px;
    box-shadow: 0px 0px 10px rgba(0, 0, 0.1);
    display: flex;
    flex-direction: column;
    padding: 10px 8px;
    box-sizing: border-box;
    h3{
        color: #E2E8F0;
        text-align: center;
        margin-top: 10px;
        font-size: 18px;
    }
`

const EpisHistContainer = styled.div`
    width: 100%;
    flex: 1;
    max-height: calc( 60% - 5px );
    background-color: #2E3A44;
    border-radius: 12px;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
    display: flex;
    flex-direction: column;
    padding: 10px 8px;
    box-sizing: border-box;
    h3{
        color: #E2E8F0;
        text-align: center;
        margin-top: 10px;
        font-size: 18px;
    }
`
const TdStatus = styled.td`
    text-align: center;
`
const StatusDiv = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
`
const Circle = styled.div`
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: ${props => props.status === 'OK' ? '#22C55E' : '#F87171'};
    margin: 0 auto;
`
const InfoContainer = styled.div`
    width: 75%;
    flex: 1;
    display: flex;
    flex-direction: column;
    margin: 0 auto 10px auto;
    box-sizing: border-box;
    p{
        color: #E2E8F0;
        font-size: 14px;
        margin: 2px 0;
    }
`


const EpiColab = () => {

    const { matricula } = useParams();

    const [colabInfo, setColabInfo] = useState([])
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState(false)

    const getUserInfo = async () => {

        //setLoading( true );
        //setError( null );

        try {

            const { data } = await axios.post('https://sistemaintegrado.palmont.com.br/Painel/API/EPI/ColaboradorInfo/', {
                matricula: matricula
            })

            console.log(data)
            setColabInfo(data)

        } catch (e) {

            setError(e);
            console.log(e)

        }

    }

    useEffect(() => {

        getUserInfo();

    }, [])

    return (
        <>
            <NavBar prevDest="EpisHome" title="EPI x COLABORADOR" />
            <GenericBody>
                {
                    loading ? <Overlay state={true} /> :
                        error ? <Overlay state={true} /> :
                            <BackgroundDiv>
                                <ColabInfoContainer>
                                    <ContainerImageColab>
                                        <img src={colabInfo.IMAGEM} alt="Colaborador" />
                                    </ContainerImageColab>
                                    <MainText>{colabInfo.NOME || ''}</MainText>
                                    <MainText2>{colabInfo.FUNCAO || ''}</MainText2>
                                    <Separator />
                                    <InfoContainer>
                                        <p><strong>MATRÍCULA:</strong> {colabInfo.MATRICULA || ''}</p>
                                        <p><strong>CENTRO CUSTO:</strong> {colabInfo.CENTRO_CUSTO || ''}</p>
                                        <p><strong>CONTRATO:</strong> {colabInfo.CONTRATO || ''}</p>
                                    </InfoContainer>
                                </ColabInfoContainer>
                                <EpisContainer>
                                    <EpisObrgContainer>
                                        <h3>EPIs OBRIGATÓRIOS</h3>
                                        <EpiTabelaContainer>
                                            <Tabela>
                                                <thead>
                                                    <tr>
                                                        <th>COD. EPI</th>
                                                        <th>DESCRIÇÃO</th>
                                                        <th>STATUS</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        colabInfo?.EPIS_OBRIGATORIOS?.length > 0 ? (
                                                            colabInfo.EPIS_OBRIGATORIOS.map((obj, index) => (
                                                                <tr key={index} >
                                                                    <td>{obj.EPI_OBRIGATORIO}</td>
                                                                    <td>{obj.DESC_OBRIGATORIO}</td>
                                                                    <TdStatus>
                                                                        <StatusDiv>
                                                                            <Circle status={obj.STATUS} />
                                                                        </StatusDiv>
                                                                    </TdStatus>
                                                                </tr>
                                                            ))
                                                        ) : (
                                                            <tr>
                                                                <td colSpan="3" style={{ textAlign: 'center' }}>Nenhum EPI Obrigatório encontrado</td>
                                                            </tr>
                                                        )
                                                    }
                                                </tbody>
                                            </Tabela>
                                        </EpiTabelaContainer>
                                    </EpisObrgContainer>
                                    <EpisHistContainer>
                                        <h3>HISTÓRICO DE EPIs</h3>
                                        <EpiTabelaContainer>
                                            <Tabela>
                                                <thead>
                                                    <tr>
                                                        <th>COD. EPI</th>
                                                        <th>DESCRIÇÃO</th>
                                                        <th>EPI PAI</th>
                                                        <th>C.A. EPI</th>
                                                        <th>VENC. C.A.</th>
                                                        <th>DURABILIDADE</th>
                                                        <th>VENC. DURABILIDADE</th>
                                                        <th>DATA ENTREGA</th>
                                                        <th>HORA</th>
                                                        <th>QUANTIDADE</th>
                                                        <th>DEVOLVIDO</th>
                                                        <th>DATA DEVOLUÇÃO</th>
                                                        <th>BIOMETRIA</th>
                                                        <th>STATUS</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        colabInfo?.HISTORICO?.length > 0 ? (
                                                            colabInfo.HISTORICO.map((obj, index) => (
                                                                <tr key={index} >
                                                                    <td>{obj.CODIGO_EPI}</td>
                                                                    <td>{obj.DESCRICAO}</td>
                                                                    <td>{obj.EPI_PAI ? obj.EPI_PAI : '-'}</td>
                                                                    <td>{obj.EPI_CA}</td>
                                                                    <td>{obj.VALIDADE_CA ? formatarData( obj.VALIDADE_CA ) : '-'}</td>
                                                                    <td>{obj.DURABILIDADE ? obj.DURABILIDADE : '-'}</td>
                                                                    <td>{ obj.VALIDADE_FINAL ? formatarData( obj.VALIDADE_FINAL ) : '-'}</td>
                                                                    <td>{ formatarData( obj.DATA_ENTREGA )}</td>
                                                                    <td>{obj.HORA_ENTREGA}</td>
                                                                    <td>{obj.QUANTIDADE}</td>
                                                                    <td>{obj.DEVOLUCAO ? 'OK' : 'PENDENTE'}</td>
                                                                    <td>{obj.DEVOLUCAO ? formatarData( obj.DEVOLUCAO ) : '-'}</td>
                                                                    <td>{obj.DIGITAL}</td>
                                                                    <td>{obj.STATUS}</td>
                                                                </tr>
                                                            ))
                                                        ) : (
                                                            <tr>
                                                                <td colSpan="14" style={{ textAlign: 'center' }}>Nenhum histórico de EPI encontrado</td>
                                                            </tr>
                                                        )
                                                    }
                                                </tbody>
                                            </Tabela>
                                        </EpiTabelaContainer>
                                    </EpisHistContainer>
                                </EpisContainer>
                            </BackgroundDiv>
                }
                { /*<ColabContainer colab={ colabInfo } /> */}
                { /*<TablesContainer episObrg={ colabInfo.EPIS_OBRIGATORIOS } historicoEpi={ colabInfo.HISTORICO } /> */}
            </GenericBody>
        </>
    )

}

export default EpiColab;